import { CreateAlert } from '../../../shared/common-alerts/SKAlerts';

const TAB_KEY_PATTERN = /^[a-z][a-z0-9_]*$/;

export const validateProductDetailTabType = (payload, setAlert) => {
  if (!payload.TabKey?.trim()) {
    CreateAlert('Please enter tab key!!', 'Warning', setAlert);
    return false;
  }
  if (!TAB_KEY_PATTERN.test(payload.TabKey.trim())) {
    CreateAlert('Tab key must be lowercase letters, numbers, and underscores only!!', 'Warning', setAlert);
    return false;
  }
  if (!payload.DefaultTitle?.trim()) {
    CreateAlert('Please enter default title!!', 'Warning', setAlert);
    return false;
  }
  if (!payload.ContentType?.trim()) {
    CreateAlert('Please select content type!!', 'Warning', setAlert);
    return false;
  }
  if (payload.DisplayOrder !== '' && payload.DisplayOrder != null) {
    const order = Number(payload.DisplayOrder);
    if (Number.isNaN(order) || order < 0) {
      CreateAlert('Display order cannot be negative!!', 'Warning', setAlert);
      return false;
    }
  }
  return true;
};
